import "./sidebar.scss";
import CifTitleLogo from "assets/imgs/icons/cifSidebarLogo.png";
import cifFullLogo from "assets/imgs/icons/logo-white-cif.png";
import SearchIcon from "assets/imgs/CSMSidebar/searchIconNoBg.svg";
import ParentContact from "assets/imgs/CSMSidebar/parentContactNobg.svg";
import DailyScheduleIcon from "assets/imgs/TutorSidebar/scheduleNobg.svg";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "routes";
import BookWhiteFilledIcon from "assets/imgs/CsmPages/BookWhiteFilled.svg";
import ClockWhiteOutlinedIcon from "assets/imgs/CsmPages/ClockWhiteOutlined.svg";
import AssignTimeSlots from "assets/imgs/CSMSidebar/assignTimeSlots.svg";
import Feedback from "assets/imgs/CSMSidebar/Feedback.svg";
import StudentList from "assets/imgs/CSMSidebar/studentList.svg";
import TutorSessions from "assets/imgs/CSMSidebar/tutorSessions.svg";
import CreateTimeSlotIcon from "assets/imgs/CSMSidebar/createTimeSlot.svg";
import CourseRequestsIcon from "assets/imgs/CSMSidebar/courseRequests.svg";
import FindTutor from "assets/imgs/CSMSidebar/findTutor.svg";
import AddSiblingIcon from "assets/imgs/CSMSidebar/addSibling.svg";
import ReferralIcon from "assets/imgs/CSMSidebar/Referral.svg";
import ReferralStatusIcon from "assets/imgs/CSMSidebar/ReferralStatus.svg";
import AddCourseIcon from "assets/imgs/CSMSidebar/addCourse.svg";
import { useState } from "react";
import { useEffect } from "react";

function Sidebar() {
  const navigate = useNavigate();
  const [expandSidebar, setExpandSidebar] = useState(false);
  const [active, setActive] = useState(0);

  const addHoverEvent = () => {
    const mainDiv = document.getElementById("csm-sidebar-main");
    mainDiv.addEventListener("mouseenter", () => setExpandSidebar(true));
    mainDiv.addEventListener("mouseleave", () => {
      const expandDiv = document.getElementById("csm-sidebar-expanded");
      expandDiv.addEventListener("mouseenter", () => setExpandSidebar(true));
      expandDiv.addEventListener("mouseleave", () => setExpandSidebar(false));
    });
    // console.log(div);
  };

  useEffect(() => {
    addHoverEvent();
  }, []);

  return (
    <div className="csmSidebar__wrapper">
      <div className="navigation__left-wrapper" id="csm-sidebar-main">
        <Link
          className={`row text-center sidebar-cif-logo-wrapper ${
            expandSidebar && "default-cursor"
          }`}
          to={ROUTES.CSM_DASHBOARD}
        >
          <div>
            <img
              src={CifTitleLogo}
              alt=""
              className={`left_menu_img ${expandSidebar && "invisible"}`}
            />
          </div>
        </Link>
        <div className="row">
          <Link
            to={ROUTES.CSM_COURSE_REQUESTS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 1 && "active"}`}
              onMouseEnter={() => setActive(1)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={CourseRequestsIcon} alt="Home" />
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_PARENT_CONTACT_DETAILS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 2 && "active"}`}
              onMouseEnter={() => setActive(2)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={ParentContact} alt="Home" />
            </div>
          </Link>
        </div>

        <div className="row">
          <Link
            to={ROUTES.CSM_STUDENT_LIST}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 3 && "active"}`}
              onMouseEnter={() => setActive(3)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={StudentList} alt="Home" />
            </div>
          </Link>
        </div>
        <hr className="hr-sidebar" />
        <div className="row">
          <Link
            to={ROUTES.CSM_ADD_SUBJECT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 4 && "active"}`}
              onMouseEnter={() => setActive(4)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={AddCourseIcon} alt="Home" />
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_ADD_SIBLING}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 5 && "active"}`}
              onMouseEnter={() => setActive(5)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={AddSiblingIcon} alt="Home" />
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_SCHEDULE}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 6 && "active"}`}
              onMouseEnter={() => setActive(6)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={DailyScheduleIcon} alt="Home" />
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_CREATE_TIME_SLOT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 7 && "active"}`}
              onMouseEnter={() => setActive(7)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={CreateTimeSlotIcon} alt="Home" />
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_VIEW_AVAILABLE_TUTORS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 8 && "active"}`}
              onMouseEnter={() => setActive(8)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={FindTutor} alt="Home" />
            </div>
          </Link>
        </div>

        <div className="row">
          <Link
            to={ROUTES.CSM_LIST_TUTOR_SESSION}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 9 && "active"}`}
              onMouseEnter={() => setActive(9)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={TutorSessions} alt="weekly schedule" />
            </div>
          </Link>
        </div>
        <hr className="hr-sidebar" />
        {/* <div className="row">
          <Link
            to={ROUTES.CSM_WEEKLY_SCHEDULE}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 6 && "active"}`}
              onMouseEnter={() => setActive(6)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={WeeklySchedule} alt="weekly schedule" />
            </div>
          </Link>
        </div> */}
        <div className="row">
          <Link
            to={ROUTES.CSM_REFERRAL}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 10 && "active"}`}
              onMouseEnter={() => setActive(10)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={ReferralIcon} alt="Home" />
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_REFERRAL_STATUS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 11 && "active"}`}
              onMouseEnter={() => setActive(11)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={ReferralStatusIcon} alt="Home" />
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_ASSIGN_TIME_SLOT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 12 && "active"}`}
              onMouseEnter={() => setActive(12)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={AssignTimeSlots} alt="Home" />
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_FEEDBACK}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 13 && "active"}`}
              onMouseEnter={() => setActive(13)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={Feedback} alt="weekly schedule" />
            </div>
          </Link>
        </div>
        {/* <hr className="hr-sidebar" /> */}

        {/* <div className="row">
          <Link
            to={ROUTES.CSM_UPCOMING_SESSIONS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`csmSidebar__icon_wrapper ${active == 12 && "active"}`}
              onMouseEnter={() => setActive(12)}
              onMouseLeave={() => setActive(0)}
            >
              <img src={TutorSessions} alt="weekly schedule" />
            </div>
          </Link>
        </div> */}
        {/* <hr className="hr-sidebar" /> */}
      </div>

      {/*expanded Sidebar */}
      <div
        className={`csm-sidebar-expand ${expandSidebar ? "visible" : ""}`}
        id="csm-sidebar-expanded"
      >
        <Link
          className="row text-center sidebar-cif-logo-wrapper"
          to={ROUTES.CSM_DASHBOARD}
        >
          <div className="expanded-menu-img-wrapper">
            <img src={cifFullLogo} alt="" className="expanded_menu_img" />
          </div>
        </Link>
        <div className="row">
          <Link
            to={ROUTES.CSM_COURSE_REQUESTS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 1 && "active"
              }`}
              onMouseEnter={() => setActive(1)}
              onMouseLeave={() => setActive(0)}
            >
              Course Requests
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_PARENT_CONTACT_DETAILS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 2 && "active"
              }`}
              onMouseEnter={() => setActive(2)}
              onMouseLeave={() => setActive(0)}
            >
              Parent Contact details
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_STUDENT_LIST}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 3 && "active"
              }`}
              onMouseEnter={() => setActive(3)}
              onMouseLeave={() => setActive(0)}
            >
              Student List
            </div>
          </Link>
        </div>
        <hr className="hr-sidebar" />
        <div className="row">
          <Link
            to={ROUTES.CSM_ADD_SUBJECT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 4 && "active"
              }`}
              onMouseEnter={() => setActive(4)}
              onMouseLeave={() => setActive(0)}
            >
              Add Courses
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_ADD_SIBLING}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 5 && "active"
              }`}
              onMouseEnter={() => setActive(5)}
              onMouseLeave={() => setActive(0)}
            >
              Add Sibling
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_SCHEDULE}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 6 && "active"
              }`}
              onMouseEnter={() => setActive(6)}
              onMouseLeave={() => setActive(0)}
            >
              Schedule
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_CREATE_TIME_SLOT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 7 && "active"
              }`}
              onMouseEnter={() => setActive(7)}
              onMouseLeave={() => setActive(0)}
            >
              Create Time Slots
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_VIEW_AVAILABLE_TUTORS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 8 && "active"
              }`}
              onMouseEnter={() => setActive(8)}
              onMouseLeave={() => setActive(0)}
            >
              Find Tutor
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_LIST_TUTOR_SESSION}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 9 && "active"
              }`}
              onMouseEnter={() => setActive(9)}
              onMouseLeave={() => setActive(0)}
            >
              List Tutor Sessions
            </div>
          </Link>
        </div>
        <hr className="hr-sidebar" />

        {/* <div className="row">
          <Link
            to={ROUTES.CSM_WEEKLY_SCHEDULE}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 6 && "active"
              }`}
              onMouseEnter={() => setActive(6)}
              onMouseLeave={() => setActive(0)}
            >
              Weekly Schedule
            </div>
          </Link>
        </div> */}
        <div className="row">
          <Link
            to={ROUTES.CSM_REFERRAL}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 10 && "active"
              }`}
              onMouseEnter={() => setActive(10)}
              onMouseLeave={() => setActive(0)}
            >
              Referral
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_REFERRAL_STATUS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 11 && "active"
              }`}
              onMouseEnter={() => setActive(11)}
              onMouseLeave={() => setActive(0)}
            >
              Referral Status
            </div>
          </Link>
          <Link
            to={ROUTES.CSM_ASSIGN_TIME_SLOT}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 12 && "active"
              }`}
              onMouseEnter={() => setActive(12)}
              onMouseLeave={() => setActive(0)}
            >
              Assign Time Slots
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_FEEDBACK}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 13 && "active"
              }`}
              onMouseEnter={() => setActive(13)}
              onMouseLeave={() => setActive(0)}
            >
              Feedback
            </div>
          </Link>
        </div>
        {/* <hr className="hr-sidebar" />
        <div className="row">
          <Link
            to={ROUTES.CSM_LIST_MY_STUDENTS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 11 && "active"
              }`}
              onMouseEnter={() => setActive(11)}
              onMouseLeave={() => setActive(0)}
            >
              List My Sessions
            </div>
          </Link>
        </div>
        <div className="row">
          <Link
            to={ROUTES.CSM_UPCOMING_SESSIONS}
            className="col-12 csmSidebar__item_col"
          >
            <div
              className={`navigationLeft__expanded-label ${
                active == 12 && "active"
              }`}
              onMouseEnter={() => setActive(12)}
              onMouseLeave={() => setActive(0)}
            >
              Upcoming Sessions
            </div>
          </Link>
        </div>
        <hr className="hr-sidebar" /> */}
      </div>
    </div>
  );
}

export default Sidebar;
